import Subscribe from './subscribe';

export default Subscribe;